import { MenuItem } from '@mui/material';
import React, { JSX } from 'react';
import styled from 'styled-components';
import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';

interface Props {
  design: FormPublicDesignFragment;
  value: string;
  children: JSX.Element;
}

const Field = styled(MenuItem)<{ design: FormPublicDesignFragment }>`
  &.MuiList-root {
    background-color: ${({ design }) => design.colors.background};
  }

  &.MuiMenuItem-root {
    background-color: ${({ design }) => design.colors.background};
    color: ${({ design }) => design.colors.question};

    &:hover {
      background-color: ${({ design }) => design.colors.button};
    }
  }

  &.MuiMenuItem-root.Mui-selected {
    background-color: ${({ design }) => design.colors.button};
  }
`;

export const StyledMenuItem = (props: Props) => {
  return <Field {...props} />;
};
